/**
 * @generated SignedSource<<673c71905151052ce76e19de8696300c>>
 * @relayHash 8e71f9d83febf0d6f3af512963ac9513
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2ea9a4782e72e48d689526085c5f5529d00e6033d08eae547913f397827dc165

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfileCardEntryPointQuery$variables = {
  cloudId: string;
  collabContextId?: string | null;
  orgId: string;
  skipKnowledgeDiscovery: boolean;
  userAri: string;
  userId: string;
  userIdString: string;
  viewerId: string;
};
export type UserProfileCardEntryPointQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserProfileCardRelay_query">;
};
export type UserProfileCardEntryPointQuery = {
  response: UserProfileCardEntryPointQuery$data;
  variables: UserProfileCardEntryPointQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collabContextId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipKnowledgeDiscovery"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userAri"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIdString"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewerId"
},
v8 = {
  "kind": "Variable",
  "name": "collabContextId",
  "variableName": "collabContextId"
},
v9 = {
  "kind": "Variable",
  "name": "orgId",
  "variableName": "orgId"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "picture"
},
v13 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v15/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v15/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v15/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v20 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v15/*: any*/)
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/)
    ]
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "url"
},
v22 = [
  (v21/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v24 = [
  (v23/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      (v23/*: any*/),
      (v14/*: any*/)
    ]
  }
],
v25 = [
  {
    "alias": "trelloUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v26 = [
  {
    "alias": "webUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v27 = [
  (v21/*: any*/),
  (v14/*: any*/)
],
v28 = [
  {
    "concreteType": "AssetsLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "web"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "UserProfileCardEntryPointQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "Variable",
            "name": "skipKnowledgeDiscovery",
            "variableName": "skipKnowledgeDiscovery"
          },
          {
            "kind": "Variable",
            "name": "userAri",
            "variableName": "userAri"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          },
          {
            "kind": "Variable",
            "name": "userIdString",
            "variableName": "userIdString"
          },
          {
            "kind": "Variable",
            "name": "viewerId",
            "variableName": "viewerId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "UserProfileCardRelay_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserProfileCardEntryPointQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "userId"
          }
        ],
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          {
            "kind": "ScalarField",
            "name": "accountStatus"
          },
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "email"
              },
              {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "department"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "location"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "organization"
                  }
                ]
              }
            ],
            "type": "AtlassianAccountUser"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "appType"
              }
            ],
            "type": "AppUser"
          },
          (v14/*: any*/)
        ]
      },
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "fields": [
                  {
                    "items": [
                      {
                        "kind": "Variable",
                        "name": "actors.0",
                        "variableName": "userAri"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "actors"
                  },
                  (v8/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 50
              }
            ],
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "concreteType": "ActivityItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ActivityNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ActivityObject",
                        "kind": "LinkedField",
                        "name": "object",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceDatabaseLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v15/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceDatabase"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceEmbedLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v15/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceEmbed"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "ConfluenceFooterComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v20/*: any*/),
                                "type": "ConfluenceInlineComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "TownsquareGoal"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "TownsquareProject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "TownsquareComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v23/*: any*/)
                                ],
                                "type": "JiraIssue"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v24/*: any*/),
                                "type": "JiraPlatformComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v24/*: any*/),
                                "type": "JiraServiceManagementComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "TrelloBoard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v25/*: any*/),
                                "type": "TrelloCard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "DevOpsDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "ExternalDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v27/*: any*/),
                                "type": "DevOpsPullRequestDetails"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "ExternalPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "DevOpsDesign"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "ExternalRemoteLink"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "MercuryFocusArea"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v27/*: any*/),
                                "type": "MercuryPortfolio"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "RadarPosition"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "RadarView"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v22/*: any*/),
                                "type": "CompassComponent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "href"
                                  }
                                ],
                                "type": "BitbucketPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "loomUrl",
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "LoomVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v28/*: any*/),
                                "type": "AssetsObject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v28/*: any*/),
                                "type": "AssetsObjectType"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v28/*: any*/),
                                "type": "AssetsSchema"
                              },
                              (v19/*: any*/)
                            ]
                          },
                          (v14/*: any*/)
                        ]
                      },
                      (v14/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "skipKnowledgeDiscovery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "userIdString"
                  },
                  (v9/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "requestingUserId",
                    "variableName": "viewerId"
                  },
                  {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "LinkedField",
                "name": "singleUser",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "KnowledgeDiscoveryUserProfile",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "KnowledgeDiscoveryUserManager",
                            "kind": "LinkedField",
                            "name": "manager",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v13/*: any*/),
                              (v12/*: any*/),
                              (v11/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                            "kind": "LinkedField",
                            "name": "thirdPartyIntegrations",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "externalId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "integrationId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "product"
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "KnowledgeDiscoverySingleUser"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2ea9a4782e72e48d689526085c5f5529d00e6033d08eae547913f397827dc165",
    "metadata": {},
    "name": "UserProfileCardEntryPointQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "af91f3e9a1928aaee3b3dc2bc550cd1d";

export default node;
